import { css, cva } from '@/styled-system/css';

export const priceOnlyContainerStyles = css.raw({
  alignItems: 'center',
  display: 'flex',
  flexGrow: 1,
  order: { base: -1, lg: 1 },
  justifyContent: { lg: 'flex-end' },
  marginRight: { lg: '400' },
});

export const mobileOnlyVerticalDividerStyles = css.raw({
  backgroundColor: 'border.subtle',
  display: 'flex',
  height: '10px',
  margin: '0 {spacing.200}',
  width: '1px',

  lg: {
    display: 'none',
  },
});

export const flexContainerStyles = css.raw({
  display: 'flex',
  flexGrow: 1,
  justifyContent: 'space-between',
  flexDirection: { base: 'column', lg: 'row' },
  alignItems: { base: 'flex-start', lg: 'center' },
  alignSelf: 'center',
});

export const middleFlexStyles = css.raw({
  display: 'flex',
  alignItems: 'center',
  marginRight: '200',
  lg: { justifyContent: 'space-between', flexGrow: 1 },
});

export const footerContainerStyles = css.raw({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
  paddingInline: { base: '400', md: '600', xxl: '104px' },
});

export const footerContainerStylesMultifamily = css.raw({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
  paddingInline: '400',
});

export const stickyListingFooterContainerStyles = cva({
  base: {
    borderTop: '1px solid {colors.border.subtle}',
    bottom: '0',
    left: '0',
    backgroundColor: 'white',
    zIndex: 'loadingMask',
    minHeight: { base: '114px', md: '0' },
    height: { md: '76px' },
    display: 'flex',
  },
  variants: {
    isVisible: {
      true: {
        position: 'static',
        boxShadow: '0',
        padding: '{spacing.400} 0',
      },
      false: {
        position: 'fixed',
        boxShadow: '0 0 7px -2px rgba(0, 0, 0, 0), 0 0 3px 0 rgba(0, 0, 0, 0.26)',
        padding: '{spacing.400} 0',
      },
    },
    isWizardView: {
      true: {},
      false: {},
    },
  },
  compoundVariants: [
    {
      isVisible: false,
      isWizardView: false,
      css: {
        left: { base: '0', xxl: '{sizes.leftNavWidth}' },
        width: { base: '100%', xxl: 'calc(100% - {sizes.leftNavWidth})' },
      },
    },
    {
      isVisible: false,
      isWizardView: true,
      css: {
        left: '0',
        width: '100%',
      },
    },
    {
      isVisible: true,
      css: {
        left: '0',
        width: '100%',
      },
    },
  ],
  defaultVariants: {
    isVisible: false,
    isWizardView: true,
  },
});
